module.exports = __webpack_public_path__ + "static/media/style.199826ea.scss";


//////////////////
// WEBPACK FOOTER
// ./src/views/avicollectDashboard/style.scss
// module id = 732
// module chunks = 0